<div class="w-100 h-100 d-flex align-items-center justify-content-center" id="loading-container">
  <ds-progress-circle variant="indeterminate" backdropVariant="solid" [size]="size()" [ngClass]="margin()" />
</div>
